import Vue from 'vue';
import App from './App.vue';
import { router } from './router';
import './utils/common';
import { isDev } from './utils/common';

// import * as fundebug from 'fundebug-javascript';
// import FundebugVue from 'fundebug-vue';

Vue.config.productionTip = false;
import * as Sentry from '@sentry/vue';
import { CaptureConsole } from '@sentry/integrations';
if (!isDev) {
  window._Sentry = Sentry;
  let openReplay = false;
  try {
    Sentry.init({
      Vue,
      dsn:
        'https://cae95c0721d15ce0d50f382740760be8@o4509796045684736.ingest.us.sentry.io/4511251033096192',
      integrations: [
        new Sentry.BrowserTracing({
          // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
          tracePropagationTargets: [
            /^https:\/\/xingbaidesign\.com/
            // /^http:\/\/app\.book\.com/
          ]
        }),
        // openReplay
        //   ? new Sentry.Replay({
        //       maskAllText: false,
        //       blockAllMedia: false
        //     })
        //   : null,
        new CaptureConsole({ levels: ['error'] })
      ],
      // 2. 忽略常见无用报错
      ignoreErrors: [
        'object PromiseRejectionEvent',
        'Script error.',
        'AxiosError',
        'content risky',
        'Large Render Blocking Asset',
        'object ErrorEvent',
        'pollCheck fn',
        'object PromiseRejectionEvent',
        /^Loading chunk .* failed$/
      ],

      // 3. 去重 & 防抖
      maxBreadcrumbs: 50,
      // Performance Monitoring
      tracesSampleRate: 0.1, //  Capture 100% of the transactions
      // Session Replay
      replaysSessionSampleRate: openReplay ? 0.1 : 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: openReplay ? 0.1 : 0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
    openReplay = true;
  } catch (error) {
    console.error(error);
  }
}

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app');
